import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import { api } from "@/lib/api";
import SectionHeading from "@/components/SectionHeading";

export default function Journal() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/posts").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  const [hero, ...rest] = posts;

  return (
    <div data-testid="journal-page" className="pt-32 pb-24 px-6 md:px-10">
      <div className="mx-auto max-w-[1400px]">
        <SectionHeading
          eyebrow="The Journal"
          title="Notes from the chair."
          subtitle="Style guides, grooming tips, and dispatches from inside the shop."
          testIdBase="journal-header"
        />

        {hero && (
          <Link
            to={`/journal/${hero.id}`}
            data-testid={`journal-hero-${hero.id}`}
            className="group grid lg:grid-cols-12 gap-8 mt-14 card-monarch overflow-hidden"
          >
            <div className="lg:col-span-7 img-zoom aspect-[16/10] bg-monarch-coal">
              <img src={hero.image} alt={hero.title} className="w-full h-full object-cover" />
            </div>
            <div className="lg:col-span-5 p-8 md:p-12 flex flex-col justify-center">
              <div className="text-[10px] uppercase tracking-[0.3em] text-monarch-gold mb-4 flex items-center gap-3">
                <Calendar className="w-3.5 h-3.5" /> {hero.date} · {hero.author}
              </div>
              <h3 className="font-serif text-3xl md:text-4xl text-monarch-cream leading-[1.1] mb-4">{hero.title}</h3>
              <p className="text-monarch-ash leading-relaxed mb-6">{hero.excerpt}</p>
              <span className="text-monarch-gold text-xs uppercase tracking-[0.22em] flex items-center gap-2 group-hover:gap-3 transition-all">
                Read the piece <ArrowRight className="w-4 h-4" />
              </span>
            </div>
          </Link>
        )}

        <div className="grid md:grid-cols-3 gap-6 mt-10">
          {rest.map((p) => (
            <Link key={p.id} to={`/journal/${p.id}`} data-testid={`journal-card-${p.id}`} className="card-monarch group overflow-hidden">
              <div className="img-zoom aspect-[4/3]">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-6">
                <div className="text-[10px] uppercase tracking-[0.3em] text-monarch-gold mb-3">{p.date}</div>
                <h3 className="font-serif text-xl text-monarch-cream leading-snug mb-3">{p.title}</h3>
                <p className="text-sm text-monarch-ash leading-relaxed">{p.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
